import { Flex, Text } from "@chakra-ui/react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
  ContractTaskChangeDto,
  ContractTaskChangeType,
  ContractTaskStatus,
} from "../../../../../../autogen/bff-api";
import { displayDateWithTime } from "../../../../../../common/formatting/displayDateWithTime";
import { Explanation } from "../../../../../../common/support/Explanation/Explanation";

interface Props {
  change: ContractTaskChangeDto;
}

export const Change = ({ change }: Props) => {
  const { t } = useTranslation();

  const getChangeName = (): string => {
    switch (change.type) {
      case ContractTaskChangeType.Description:
        return t("description");
      case ContractTaskChangeType.DueDate:
        return t("due date");
      case ContractTaskChangeType.ResponsibleParty:
        return t("responsible party");
      case ContractTaskChangeType.Status:
        return t("status");
      case ContractTaskChangeType.Title:
        return t("title");
    }
  };

  const statusLabel = (value: string): string => {
    switch (value) {
      case ContractTaskStatus.Open:
        return t("Open");
      case ContractTaskStatus.Completed:
        return t("Completed");
      default:
        return value;
    }
  };

  const displayValue = (value: string): string =>
    change.type === ContractTaskChangeType.Status ? statusLabel(value) : value;

  const getChangeText = () => {
    return `${t("Changed")} ${getChangeName()} ${t("from")} "${displayValue(change.oldValue)}" ${t("to")} "${displayValue(change.newValue)}"`;
  };
  return (
    <Flex flexDirection={"column"} mt="15px">
      <Flex>
        <Text fontWeight={"semibold"} fontSize="md" color="smTaskActivityText">
          {change.changedByFullName}
        </Text>
        <Explanation enabled={true} text={displayDateWithTime(change.createdAt, t("at"))}>
          <Text fontSize="sm" color="smTaskActivityText" ml="15px" mt="1px">
            {moment(change.createdAt).fromNow()}
          </Text>
        </Explanation>
      </Flex>
      <Flex mt="5px">
        <Text fontStyle={"italic"}>{getChangeText()}</Text>
      </Flex>
    </Flex>
  );
};
